import {
    FaCar,
    FaMoneyBillWave,
    FaImage,
    FaEdit,
    FaTrash,
} from "react-icons/fa";

import {
    MdCategory,
    MdDateRange,
} from "react-icons/md";

import {
    TbRoad,
} from "react-icons/tb";

import {
    formatNumber,
} from "../../../../services/numberFormatter";

import styles from "./ExpenseCard.module.css";

const ExpenseCard = ({

    expense,

    actions,

}) => {

    return (

        <div className={styles.card}>

            <div className={styles.header}>

                <div className={styles.car}>

                    <FaCar />

                    <span>

                        {expense.car_title}

                    </span>

                </div>

                <div className={styles.amount}>

                    <FaMoneyBillWave />

                    <span>

                        {

                            // formatNumber(

                                expense.cost

                            // )

                        }

                    </span>

                    <small>

                        تومان

                    </small>

                </div>

            </div>

            <div className={styles.item}>

                <MdCategory />

                <span>

                    {expense.category_title} ({expense.category_desc})

                </span>

            </div>

            <div className={styles.body}>

                {/* <div className={styles.item}>

                    <MdCategory />

                    <span>

                        {expense.category_title} ({expense.category_desc})

                    </span>

                </div> */}

                <div className={styles.item}>

                    <MdDateRange />

                    <span>

                        {expense.operDonDateP}

                    </span>

                </div>

                <div className={styles.item}>

                    <TbRoad />

                    <span>

                        {

                            // formatNumber(

                                expense.operDonKM

                            // )

                        }

                    </span>

                    <small>

                        کم

                    </small>

                </div>

            </div>

            {

                expense.description &&

                <div className={styles.description}>

                    {expense.description}

                </div>

            }

            <div className={styles.footer}>

                <button

                    type="button"

                    className={styles.action}

                    onClick={()=>

                        actions?.onReceipt?.(

                            expense

                        )

                    }

                >

                    <FaImage />

                    <span>

                        فاکتور

                    </span>

                </button>

                <button

                    type="button"

                    className={styles.action}

                    onClick={()=>

                        actions?.onEdit?.(

                            expense

                        )

                    }

                >

                    <FaEdit />

                    <span>

                        ویرایش

                    </span>

                </button>

                <button

                    type="button"

                    className={`${styles.action} ${styles.delete}`}

                    onClick={()=>

                        actions?.onDelete?.(

                            expense

                        )

                    }

                >

                    <FaTrash />

                    <span>

                        حذف

                    </span>

                </button>

            </div>

        </div>

    );

};

export default ExpenseCard;